import React from 'react'
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
    root: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      height: '100%',
      textAlign: 'center'
    },
    image: {
      marginTop: 50,
      maxWidth: '100%',
      width: 560
    }
}));

function NotFound404() {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Typography variant="h1">
              404 - page you are looking for isn’t found
            </Typography>
            <img
              alt="Under development"
              className={classes.image}
              src="/images/404.svg"
            />
        </div>
    )
}

export default NotFound404

